import { ReactNode } from 'react';

const FormFieldError = ({ error }: { error: ReactNode }): JSX.Element => {
  return <div className="mt-1 text-red text-xs">{error}</div>;
};

export default FormFieldError;
